import { render, staticRenderFns } from "./basic-info-item.vue?vue&type=template&id=7828a629&scoped=true&"
import script from "./basic-info-item.vue?vue&type=script&lang=js&"
export * from "./basic-info-item.vue?vue&type=script&lang=js&"
import style0 from "./basic-info-item.vue?vue&type=style&index=0&id=7828a629&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828a629",
  null
  
)

export default component.exports